import React from "react";
import { Link } from "react-router-dom"; // Link import kiya
import "bootstrap/dist/css/bootstrap.min.css";
// import Navr from '../Navbar/Navr';
import Footer from "./Footer";
import img from "../Ecomphotos/f1.jpg";
import eh1 from "../Ecomphotos/eh1.jpg";
import eh2 from "../Ecomphotos/eh2.jpg";
import eh3 from "../Ecomphotos/eh3.jpg";
// import './App.css';

function Main() {
  const handleWhatsAppBooking = () => {
    const phoneNumber = "919376720138"; // Apna number yahan dalein
    const message =
      "Hello Tillu Amplifier, I want to book a DJ setup for my event.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank"); // Naye tab me khulega
  };
  return (
    <>
      <div className="">
        {/* 1. HERO SECTION (Full Screen) */}
        <section className="hero-section d-flex align-items-center text-center">
          <div className="container">
            {/* Title responsive text styling ke sath */}
            <h1 className="hero-title">TILLU EVENTS</h1>

            <p className="hero-tagline">EVENTS • WEDDINGS • CELEBRATIONS</p>

            {/* Mobile: Vertical (Column), Desktop: Horizontal (Row) */}
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mt-4">
              {/* Button 1: Full width on mobile for easy tapping */}
              <button
                onClick={handleWhatsAppBooking}
                className="btn-neon-lg mobile-btn"
              >
                Book Now
              </button>

              {/* Button 2: Same width style */}
              <Link
                to="/gallery"
                className="btn btn-outline-light rounded-pill px-5 py-3 fw-bold mobile-btn"
              >
                WATCH DEMO
              </Link>
            </div>
          </div>
        </section>

        {/* 2. ABOUT OWNER & VISION (Personal Touch) */}
        <section className="py-5 bg-black">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4">
                <img
                  src={img}
                  alt="Event Setup"
                  className="img-fluid rounded-4 shadow-lg border border-secondary"
                />
              </div>
              <div className="col-lg-6">
                <h2 className="display-4 fw-bold text-white mb-3">
                  Who We Are
                </h2>

                <p className="lead text-secondary">
                  Tillu Events is not just an event company, it’s an experience.
                  For more than 10 years, we have been creating unforgettable
                  memories through weddings, concerts, parties, and grand
                  celebrations.
                </p>

                <p className="text-secondary mb-4">
                  From planning to execution, we focus on perfection. Our
                  professional team, premium sound, lighting, and stage setups
                  ensure your event looks spectacular and feels magical.
                </p>

                <div className="row text-center mt-4">
                  <div className="col-4">
                    <h3 className="text-info fw-bold">300+</h3>
                    <small className="text-secondary">Successful Events</small>
                  </div>
                  <div className="col-4">
                    <h3 className="text-warning fw-bold">100+</h3>
                    <small className="text-secondary">Wedding Projects</small>
                  </div>
                  <div className="col-4">
                    <h3 className="text-success fw-bold">24/7</h3>
                    <small className="text-secondary">Event Support</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. PREMIUM SERVICES (Detailed) */}
        <section className="py-5" style={{ background: "#0a0a0a" }}>
          <div className="container  text-center">
            <h2 className="section-title">Our Premium Services</h2>

            <div className="row g-4 mt-4">
              {/* Card 1 */}
              <div className="col-md-4">
                <div className="glass-card">
                  <div className="display-1 mb-3">🔊</div>
                  <h3 className="text-white">Event Production</h3>
                  <p className="text-secondary">
                    Complete event planning and execution including stage
                    design, sound systems, lighting, LED walls, and on-ground
                    management for all types of events.
                  </p>
                  <Link
                    to="/services/sound"
                    className="text-info text-decoration-none"
                  >
                    Learn More &rarr;
                  </Link>
                </div>
              </div>

              {/* Card 2 */}
              <div className="col-md-4">
                <div className="glass-card">
                  <div className="display-1 mb-3">🎇</div>
                  <h3 className="text-white">Sound & Lighting</h3>
                  <p className="text-secondary">
                    High-quality sound systems, line arrays, DJ setups,
                    intelligent lights, laser shows, CO2 effects, and special
                    event lighting solutions.
                  </p>
                  <Link
                    to="/services/light"
                    className="text-info text-decoration-none"
                  >
                    Learn More &rarr;
                  </Link>
                </div>
              </div>

              {/* Card 3 */}
              <div className="col-md-4">
                <div className="glass-card">
                  <div className="display-1 mb-3">💍</div>
                  <h3 className="text-white">Wedding Events</h3>
                  <p className="text-secondary">
                    From royal entries to grand varmala and unforgettable
                    receptions, we design dream weddings with themed decor,
                    music, lighting, and effects.
                  </p>
                  <Link
                    to="/services/wedding"
                    className="text-info text-decoration-none"
                  >
                    Learn More &rarr;
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. OUR GEAR (Technical Expertise Showcase) */}
        <section className="py-5 bg-black border-top border-dark">
          <div className="container text-center">
            <p className="text-uppercase text-secondary letter-spacing-2">
              Powered By Top Brands
            </p>
            <div className="d-flex justify-content-center flex-wrap gap-5 mt-4 opacity-50">
              <h2 className="text-white">JBL Professional</h2>
              <h2 className="text-white">RCF Audio</h2>
              <h2 className="text-white">Pioneer DJ</h2>
              <h2 className="text-white">Yamaha</h2>
              <h2 className="text-white">Sennheiser</h2>
            </div>
          </div>
        </section>

        {/* 5. GALLERY PREVIEW */}
        <section className="" style={{ background: "#050505" }}>
          <div className="container py-5">
            <h2 className="section-title text-center w-100">
              Event Highlights
            </h2>
            <div className="row g-3 mt-4">
              <div className="col-md-4 gallery-item">
                <img src={eh1} className="gallery-img" alt="Event 1" />
              </div>
              <div className="col-md-4 gallery-item">
                <img src={eh2} className="gallery-img" alt="Event 2" />
              </div>
              <div className="col-md-4 gallery-item">
                <img src={eh3} className="gallery-img" alt="Event 3" />
              </div>
              {/* <div className="col-md-8 gallery-item">
              <img src="https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?auto=format&fit=crop&w=1200&q=80" className="gallery-img" alt="Event 4"/>
            </div> */}
              <div className="col-md-4 gallery-item d-flex align-items-center justify-content-center bg-dark rounded-4 border border-secondary">
                <Link
                  to="/gallery"
                  className="btn btn-outline-info rounded-circle p-4"
                >
                  View All <br />
                  Photos
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* 6. CALL TO ACTION (Final Push) */}
        <section
          className="py-5 text-center"
          style={{ background: "linear-gradient(45deg, #220033, #000000)" }}
        >
          <div className="container ">
            <h2 className="display-3 fw-bold mb-4 text-white">
              Let’s Make Your Event Unforgettable!
            </h2>

            <p className="lead text-light mb-5 w-75 mx-auto">
              Tillu Events is ready to turn your vision into reality. Limited
              dates available — book your event today.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Link
                to="/contact"
                className="btn-neon-lg bg-white text-dark border-white"
              >
                Contact Us Now
              </Link>
              <Link
                to="#"
                className="btn btn-outline-light rounded-pill px-3 py-3"
              >
                Check Packages
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
      </div>
      <Footer />
    </>
  );
}

export default Main;
